import React, { Dispatch, SetStateAction, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { CloseIcon } from './AppIcons';
import { useForm } from 'react-hook-form';
import { Dialog, DialogContent, DialogTitle, Button, Grid2, IconButton } from '@mui/material';
import ContentsService from '../../content-creation/services/contents.services';

interface Props {
  setOpenPopup: Dispatch<SetStateAction<boolean>>;
  action: string;
  themeId: number | null;
  setRefresh: Dispatch<SetStateAction<boolean>>;
}

const useStyles = makeStyles({
  paper: {
    minWidth: '320px !important',
    height: '205px',
    borderRadius: '21px',
    padding: '16px',
    boxShadow: 'rgba(242, 242, 242, 1)',
  },
  header: {
    fontSize: '16px',
    verticalAlign: 'text-top',
  },
  close: {
    fontSize: '50px !important',
    color: '#5F6774 !important',
    '& path': {
      fill: `#2C2C2C !important`,
    },
  },
  input: {
    backgroundColor: '#fff',
    height: '40px',
    borderRadius: '5px',
    border: '1px solid #E1E3E8 !important',
  },
  save: {
    width: '71px',
    height: '38px',
    fontSize: '18px !important',
    fontFamily: 'Lato !important',
    backgroundColor: '#F67570 !important',
    boxShadow: 'none !important',
    color: '#fff !important',
    '& g path': {
      fill: '#ffffff !important',
    },
  },
  cancel: {
    height: '40px !important',
    fontSize: '16px !important',
    color: '#F67570 !important',
    fontFamily: 'Lato !important',
    marginRight: '24px !important',
  },
});

const CategoryOrSubCategoryPopup: React.FC<Props> = ({ setOpenPopup, action, themeId, setRefresh }) => {
  const classes = useStyles();
  const { register } = useForm({ mode: 'all' });
  const [name, setName] = useState('');

  const handleSave = async () => {
    if (action === 'addCategory') {
      await ContentsService.createCategory(name);
    } else {
      if (themeId) {
        await ContentsService.createSubCategory(name, themeId);
      } else {
        throw Error('Please select Theme before adding Sub category');
      }
    }
    setOpenPopup(false);
    setRefresh(true);
  };

  return (
    <Dialog
      open
      aria-modal="true"
      role="dialog"
      PaperProps={{
        onClick: (e: any) => e.stopPropagation(),
        className: classes.paper,
      }}
    >
      <DialogTitle sx={{ padding: 0 }}>
        <Grid2 container justifyContent="space-between" alignItems="center">
          <Grid2>
            <span className={classes.header}>{`Create New ${
              action === 'addCategory' ? 'Category' : 'Sub Category'
            }`}</span>
          </Grid2>
          <Grid2 container justifyContent="flex-end">
            <IconButton onClick={() => setOpenPopup(false)} role="button" sx={{ padding: 0 }}>
              <CloseIcon className={classes.close} />
            </IconButton>
          </Grid2>
        </Grid2>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <Grid2 container direction="column">
          <label style={{ fontSize: '12px' }}>Name</label>
          <input
            {...register('name', { required: true })}
            name="name"
            id="name"
            className={classes.input}
            onChange={(e) => setName(e.target.value)}
          />
        </Grid2>

        <Grid2 container mt={2} justifyContent="end">
          <Button variant="text" type="button" className={classes.cancel} onClick={() => setOpenPopup(false)}>
            cancel
          </Button>
          <Button size="small" className={classes.save} variant="contained" onClick={handleSave}>
            <span style={{ fontSize: 'h5', textTransform: 'none' }}>Create</span>
          </Button>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

export default CategoryOrSubCategoryPopup;
